/**
 * @generated SignedSource<<7ea2eae8436e472fab53e09fb1d5ab5a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioToolType = "AD_GENERATOR" | "MAGIC_SWAP" | "MODEL_GENERATION3_D" | "MULTI_IMAGE_FUSION" | "PRODUCT_STAGING" | "SIDE_GENERATION" | "STANDARD" | "UPSCALER" | "VIDEO_GENERATION" | "VIRTUAL_TRY_ON";
export type aiStudioImageModelsQuery$variables = Record<PropertyKey, never>;
export type aiStudioImageModelsQuery$data = {
  readonly aiStudioImageModels: ReadonlyArray<{
    readonly allowedAspectRatios: ReadonlyArray<string>;
    readonly model: string;
    readonly serviceID: number;
    readonly toolType: AIStudioToolType;
  }>;
};
export type aiStudioImageModelsQuery = {
  response: aiStudioImageModelsQuery$data;
  variables: aiStudioImageModelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AIStudioImageModelInfo",
    "kind": "LinkedField",
    "name": "aiStudioImageModels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toolType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedAspectRatios",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiStudioImageModelsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiStudioImageModelsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "e6fef26c6c17ccc7bf0478b3955f6d61",
    "id": null,
    "metadata": {},
    "name": "aiStudioImageModelsQuery",
    "operationKind": "query",
    "text": "query aiStudioImageModelsQuery {\n  aiStudioImageModels {\n    toolType\n    serviceID\n    model\n    allowedAspectRatios\n  }\n}\n"
  }
};
})();

(node as any).hash = "7eeca84b72340914bbcae58097315dc8";

export default node;
